module.exports = __webpack_public_path__ + "191b32e3c7a6692686619bca5f2bfc93.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/P28 - TempleApproach - Call to Arms copy.jpg
// module id = 151
// module chunks = 0